import dayjs from "dayjs";

export const dateCheck = (from, to, check) => {
  var fDate, lDate, cDate;
  fDate = Date.parse(from);
  lDate = Date.parse(to);
  cDate = Date.parse(check);

  if (cDate <= lDate && cDate >= fDate) {
    return true;
  }
  return false;
}

export function getDaysInMonth(month, year) {
  return new Date(year, month + 1, 0).getDate();
}

export function getNumberSuffix(number) {
  const suffixes = ["th", "st", "nd", "rd"];
  const suffixIndex = number % 100;
  return suffixes[(suffixIndex - 20) % 10] || suffixes[suffixIndex] || suffixes[0];
}

export const formatDate = (createdAt) => {
  const date = new Date(createdAt.seconds * 1000);
  const formattedDate = dayjs(date).format("DD-MM-YYYY");
  const isToday = dayjs().isSame(date, "day");
  return `${formattedDate}${isToday ? " Today" : ""}`;
};